import { useSyncExternalStore } from "react";

/**
 * True at the shell's desktop width (1024px and up), the same breakpoint as Tailwind's `lg`.
 *
 * For the few places where the two widths render different trees rather than the same tree styled
 * differently: the inbox shows the list and the thread side by side at desktop, and only the thread
 * on a phone. Everywhere else, CSS decides. Without `matchMedia` (an old test DOM) it answers
 * false, the phone layout, which works at every width.
 */
export const DESKTOP_QUERY = "(min-width: 1024px)";

function query(): MediaQueryList | null {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return null;
  return window.matchMedia(DESKTOP_QUERY);
}

function subscribe(listener: () => void): () => void {
  const list = query();
  if (!list) return () => {};
  list.addEventListener("change", listener);
  return () => list.removeEventListener("change", listener);
}

function read(): boolean {
  return query()?.matches ?? false;
}

export function useIsDesktop(): boolean {
  return useSyncExternalStore(subscribe, read, () => false);
}
